// Utilities for background video elements.

$(function() {
	var tabBlurred = false;

	// Include a timeout so that Slick does its thing first.
	setTimeout(function() {
		var backgroundVideos = $('.background_media video');

		backgroundVideos.each(function() {
			var video = this;
			if (video.readyState == 4)
				$(video).addClass('loaded');

			video.addEventListener("playing", function(e) {
				// Loaded
				if (video.readyState == 4) {
					$(video).addClass('loaded');
				}
			});
		});


		var resizeVideos = function() {
			backgroundVideos.each(function() {
				var video = $(this);

				video.css('width', '').css('height', '');
				var videoWidth = video.width();
				var videoHeight = video.height();

				var parent = video.parent();
				var parentWidth = parent.width();
				var parentHeight = parent.height();

				var aspectRatio = videoWidth/videoHeight;
				var parentAspectRatio = parentWidth/parentHeight;

				// Landscape aspect ratio
				if (videoWidth > videoHeight) {
					if (parentAspectRatio > aspectRatio) {
						video.css('width', '100%').css('height', 'auto');
					} else {
						video.css('height', '100%').css('width', 'auto');
					}
				// Portrait aspect ratio
				} else {
					if (parentAspectRatio < aspectRatio) {
						video.css('height', '100%').css('width', 'auto');
					} else {
						video.css('height', 'auto').css('width', '100%');
					}
				}

				video.addClass('resized');
			});
		}

		// Cover parent container.
		$(window).resize(resizeVideos);
		resizeVideos();

		// Resize when tab is refocused so if browser is resizes with tab in background everything looks good.
		$(window).on('focus', function() {
			if (tabBlurred) {
				resizeVideos();
				tabBlurred = false;
			}
		}).on('blur', function() {
			tabBlurred = true;
		});
	}, 500);
});